import { CookingStationName } from '../../libs';

export enum ViewTypes {
  OVERVIEW = 'overview',
  SECTIONS = 'sections'
}

export interface ComponentsCheckFilters {
  stations: CookingStationName[];
  statuses: string[];
}

export enum ComponentStatus {
  completed = 'completed',
  pending = 'pending',
  verified = 'verified'
}
